import { Icons, Images } from 'Assets';

const PageHeaders: Record<Stage, HeaderParts> = {
  default: {
    title: {
      text: '',
    },
    subTitle: '',
  },
  Redirect: {
    title: {
      text: 'Redirection',
    },
    subTitle: 'Vous allez être redirigé',
  },
  'Connexion / Registration Page': {
    title: {
      text: 'Connexion ou inscription',
    },
    subTitle: 'Saisissez votre e-mail pour vous connecter ou créer un compte',
  },
  'Connexion Page': {
    title: {
      text: 'Connexion',
    },
    subTitle: 'Saisissez votre mot de passe pour vous connecter',
  },
  'Registration Page': {
    title: {
      text: 'Création de compte',
    },
    subTitle: 'Saisissez les informations vous concernant',
  },
  'Reset Password Page': {
    title: {
      text: 'Mot de passe oublié',
    },
    subTitle: 'Nous allons envoyer un e-mail à votre adresse qui vous permettra de réinitialiser facilement votre mot de passe.',
  },
  'Email sent OK': {
    title: {
      text: 'E-mail envoyé',
      icon: Icons.GreenCheck,
    },
    subTitle: `Si un compte associé à cet identifiant existe, vous allez recevoir un e-mail de réinitialisation d'ici quelques instants.`,
  },
  'Confirmation Page': {
    title: {
      text: 'Mon nouveau mot de passe',
    },
    subTitle: `Il ne vous reste plus qu'à créer votre nouveau mot de passe en respectant les conditions ci-dessous.`,
  },
  'Password update OK': {
    image: {
      src: Images.Confetti,
      className: 'h-[148px] w-[207px] mx-auto',
    },
    title: {
      text: 'Mot de passe modifié',
    },
    subTitle: `Votre mot de passe a été modifié. Pour accéder à votre compte, cliquez sur le bouton ci-dessous.`,
  },
  'OTP Page': {
    title: {
      text: 'Code de connexion envoyé',
      icon: Icons.GreenCheck,
    },
    subTitle: `Nous venons de vous adresser un e-mail avec un code de connexion. Vous pouvez consulter dès maintenant votre messagerie. Pensez également à vérifier dans les courriers indésirables.`,
  },
  'Retry or resend OTP': {
    title: {
      text: 'Code de connexion envoyé',
      icon: Icons.GreenCheck,
    },
    subTitle: `Nous venons de vous adresser un e-mail avec un code de connexion. Vous pouvez consulter dès maintenant votre messagerie. Pensez également à vérifier dans les courriers indésirables.`,
  },
  'Locked User Page': {
    title: {
      text: 'Accès temporairement bloqué',
    },
  },
  'Associate Account': {
    title: {
      text: 'Associer mes comptes Darty & Paypal',
    },
  },
  'Captcha Page': {
    title: {
      text: 'Vérification de sécurité',
    },
    subTitle: 'Veuillez valider le captcha pour continuer :',
  },
};

export const getHeaders = (stage?: Stage): HeaderParts => PageHeaders[stage || 'default'] || PageHeaders['default'];

export interface HeaderParts {
  image?: HeaderImage;
  title: HeaderTitle;
  subTitle?: string;
}

export interface HeaderImage {
  src: string;
  className: string;
}

export interface HeaderTitle {
  text: string;
  icon?: string;
}
